import type { Table } from "@tanstack/react-table";
import { Button } from "components/ui/Button";
import { ChevronLeftIcon } from "lucide-react";

interface TablePaginationProps<T extends Record<string, unknown>> {
  table: Table<T>;
}

export default function TablePagination<T extends Record<string, unknown>>({ table }: TablePaginationProps<T>) {
  const hasMultiplePages = table.getPageCount() > 1;

  if (!hasMultiplePages) {
    return null;
  }

  return (
    <div className="inline-flex rounded-md border border-slate-300 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-800">
      <Button
        variant="ghost"
        className="px-2"
        onClick={() => table.previousPage()}
        disabled={!table.getCanPreviousPage()}
      >
        <ChevronLeftIcon className="h-5 w-5" />
      </Button>
      <div className="flex w-14 select-none items-center justify-center border-x border-slate-300 px-2 text-sm dark:border-slate-700">
        {table.getState().pagination.pageIndex + 1}/{table.getPageCount().toLocaleString()}
      </div>
      <Button variant="ghost" className="px-2" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
        <ChevronLeftIcon className="h-5 w-5 rotate-180 transform" />
      </Button>
    </div>
  );
}
